import React from 'react';
import styled from 'styled-components';
import { Typography } from '@routific/hive/v5';

const Barcode = styled(Typography)`
  flex: 1;
  word-break: break-word;
  overflow-wrap: break-word;
  min-width: 0;
`;

interface Props {
  children?: React.ReactNode;
  'data-testid'?: string;
}

const PackageBarcode: React.FC<Props> = ({ children, 'data-testid': testId }) => (
  <Barcode variant="body" data-testid={testId}>
    {children}
  </Barcode>
);

export default PackageBarcode;
